import { Theme, Colors, TransparentColors } from '@shared/interfaces/themes';

import { rgba } from 'polished';

const colors: Colors = {
  buttonDisabled: '#9CA3AF',
  cardBackground: '#F9FAFB',
  cardBorder: '#E5E7EB',
  copyrightText: '#4B5563',
  lightMint: '#b5fec1',
  forestGreen: '#2b8f28',
  apple: '#2EB83C',
  athensGray: '#F3F4F6',
  textPrimary: '#1F2A37',
  textSecondary: '#6B7280',
  divider: '#D1D5DB',
  scarpaFlow: '#58585B',
  alabaster: '#FAFAFA',
  white: '#FFFFFF',
  darkGrey: '#5c656c',
  middleGrey: '#9da0a3',
  alto: '#E0E0E0',
  cerulean: '#00AEEF',
  flushOrange: '#FF8500',
  iron: '#CDCFD0',
  lightIron: '#dfe2e4',
  concrete: '#F3F2F2',
  scarlet: '#FF2C00',
  tundora: '#424242',
  silverTree: '#51b694',
  anzac: '#dcb24c',
  black: '#000',
  fiord: '#424770',
  darkMercury: '#E3E3E3',
  grayChateau: '#9EA3A6',
  nevada: '#666E73',
  silverSand: '#B6BBBE',
  turquoise: '#47CFCB',
  cornflowerBlue: '#17242a',
  edward: '#a3b1b1',
  monument: '#858A8E',
  transparent: 'transparent',
  bombay: '#B4B5B7',
  oxfordBlue: '#334A54',
  osloGray: '#989DA0',
  blackHaze: '#E7E9E9',
  monza: '#d0021b',
  nebula: '#d2dcdb',
  mulberry: '#cf4790',
  offGreen: '#e1f7f6',
  midnightBlue: '#001E6D',
  sunglow: '#FFC439',
  saffron: '#F2BA38',
  karry: '#FFEAD4',
  keppel: '#37A5A2',
  outerSpace: '#2d3a3f',
  robinEggBlue: '#00BAB5',
  blazeOrange: '#FF6C00',
  coral: '#FF984D',
  puertoRico: '#4DBC96',
  olsoGray: '#8b9194',
  wildSand: '#F4F4F4',
};

const transparentColors: TransparentColors = {
  turquoise10: rgba(colors.turquoise, 0.1),
  turquoise50: rgba(colors.turquoise, 0.5),
  nevada20: rgba(colors.nevada, 0.2),
  lightIron50: rgba(colors.lightIron, 0.5),
  black15: rgba(colors.black, 0.15),
  black25: rgba(colors.black, 0.25),
  black50: rgba(colors.black, 0.5),
  black75: rgba(colors.black, 0.75),
  flushOrange20: rgba(colors.flushOrange, 0.2),
  flushOrange40: rgba(colors.flushOrange, 0.4),
  white60: rgba(colors.white, 0.6),
  cornflowerBlue30: rgba(colors.cornflowerBlue, 0.3),
  puertoRico50: rgba(colors.puertoRico, 0.5),
};

export const theme: Theme = {
  colors,
  transparentColors,
};

declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}
